import { icons } from 'lucide-react';

const Icon = ({ name, color, size, width }) => {
    const LucideIcon = icons[name];
    if (!LucideIcon) return null;

    return <LucideIcon color={color} size={size ?? 18} strokeWidth={width ?? 1.8} absoluteStrokeWidth={false}/>;
};

export default Icon;